<div class="my" id="this">
    <div class="container ">
        <div class="row">
            <div class="col-md-9 p-3 col9">
                <img src="./assets/PayG Doc Logo 2.svg" class="wth" alt="">
            </div>
           
            <div class="col-md-3 p-3 col3">
                <div class="row">
                    <div class="col-md-5  col5 dropdown ">
                        <button class="btn text-white " *ngIf="english" style="    width: 110%;">Login&nbsp;<img
                                src="./assets/arrowdown2.svg" alt=""></button>
                        <button class="btn text-white " *ngIf="hindi">लॉग इन करें&nbsp;<img
                                src="./assets/arrowdown2.svg" alt=""></button>
                        <div class="dropdown-content">
                            <a href="https://payg.in/merchant/#/login" target="_blank"><label for=""
                                    *ngIf="english">Merchant</label></a>
                            <a href="https://payg.in/mms/#/login" target="_blank"><label for=""
                                    *ngIf="english">Sales Partner</label></a>
                            <a href="https://payg.in/merchant/#/login" target="_blank"><label for=""
                                    *ngIf="hindi">व्यापारी</label></a>
                            <a href="https://payg.in/mms/#/login" target="_blank"><label for=""
                                    *ngIf="hindi">वितरक</label></a>
                        </div>
                    </div>
                    <div class="col-md-5 col5">
                        <a href="https://payg.in/merchant/#/registration/CreateMerchant" target="_blank" style="    position: relative;
                        right: 23%;">
                            <button class="btn text-white sign-mrg" *ngIf="english">SignUp</button></a>
                        <a href="https://payg.in/merchant/#/registration/CreateMerchant" target="_blank" style="    position: relative;
                        right: 23%;">
                            <button class="btn text-white sign-mrg" *ngIf="hindi">साइन अप करें</button></a>
                    </div>
                    <div class="col-md-2 lang dropdown">
                        <button class="btn text-white "> <img src="./assets/translate (2).svg" alt="" style="    position: relative;
                            right: 90%; width: 35px;"></button>
                        <div class="dropdown-content " style="    position: absolute;right: 0%;">
                            <!-- <label for="" (click)="English('english')"
                                [ngClass]="{'language ':lang=='english'}" *ngIf="english">English</label>
                            <label for="" (click)="Hindi('hindi') "
                                [ngClass]="{'language ':lang=='hindi'}" *ngIf="english">Hindi</label>
                                <label for="" (click)="English('english')"
                                [ngClass]="{'language ':lang=='english'}" *ngIf="hindi">अंग्रेज़ी</label>
                            <label for="" (click)="Hindi('hindi') "
                                [ngClass]="{'language ':lang=='hindi'}" *ngIf="hindi">हिंदी</label> -->
                            <ul (click)="language($event)">
                                <li value="english" style="position: relative;
                                    right: 18px;
                                    top: 2px;">English</li>
                                <li value="hindi" style="position: relative;
                                    right: 18px;
                                    top: 7px;">हिंदी</li>
                            </ul>
                        </div>
                    </div>


                </div>
            </div>
            <div class="col-md-6 mt-4 col6">
                <h2 class="text-white mt-2  h-txt" *ngIf="english">PayG Documentations</h2>
                <h2 class="text-white mt-2  h-txt" *ngIf="hindi">पे जी दस्तावेज़</h2>
                
                <p class="mt-3 txt " style="color: var(--grey6, #F7F8F8);" *ngIf="english">Effortlessly integrate PayG
                    Payment
                    Gateway with our
                    developer-friendly guide and explore comprehensive details on all our products.</p>
                <p class=" txt " style="color: var(--grey6, #F7F8F8);" *ngIf="hindi">पे जी भुगतान को सहजता से एकीकृत
                    करें
                    हमारे साथ प्रवेश द्वार
                    डेवलपर-अनुकूल मार्गदर्शिका और हमारे सभी उत्पादों पर व्यापक विवरण देखें।</p>
            </div>
            <div class="col-6  mb-5 text-center col6  ">
                <img src="./assets/Header2.gif" class="img" alt="">
            </div>
        </div>
        <div class="row mobile">
            <div class="col-md-10 col10 hide text-center">

                <div class="input-box text-center tablet" *ngIf="english">
                    <i class="fa fa-search" aria-hidden="true"></i>


                    <input type="text" #bar (keyup.enter)="getValue(bar.value)"
                        placeholder="Search product tutorials, developer guides, etc.    " />


                    <button class="button " style=" border-radius: 20px;" (click)="getValue(bar.value)"
                        *ngIf="english">Search</button>

                </div>
                <div class="input-box text-center tablet" *ngIf="hindi">
                    <i class="fa fa-search" aria-hidden="true"></i>


                    <input type="text" #bar (keyup.enter)="getValue(bar.value)"
                        placeholder="उत्पाद ट्यूटोरियल, डेवलपर गाइड आदि खोजें।  " />



                    <button class="button" style=" border-radius: 20px; " (click)="getValue(bar.value)"
                        *ngIf="hindi">खोज</button>
                </div>

            </div>
            <div class="col-md-2 col2 tbl-2">
                <div class="crd bd" (click)="table()">
                    <img src="./assets/tbl.svg" alt="" width="100%">
                </div>
            </div>

            <div class="col-md-8 col8 hand-b">

                <div class=" text-center tx-wd" *ngIf="dropdown">

                    <div class="input-box text-center">
                        <div class="row">
                            <div class="col-md-2">
                                <i class="fa fa-bars" aria-hidden="true"></i>
                            </div>
                            <div class="col-md-10"><select class="form-select hand-bar"
                                    aria-label="Default select example" (change)="menutype($event)">
                                    <option *ngFor="let menus of menu" value="{{menus}}">{{menus}} </option>

                                </select></div>
                        </div>
                    </div>

                </div>
                <div class="text-center  tx-wd" *ngIf="searchbar">
                    <div class="input-box text-center">


                        <input type="text" #mob placeholder="Search product tutorials, developer guides, etc."
                            (keyup)="getValue(mob.value)" />
                        <button class="btn"> <i class="fa fa-search" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
            <div class="col-md-2 col2 hand-b " style="position: relative;
            left: 15px;">

                <div class="p-1 input-box" *ngIf="dropdown" (click)="search()">
                    <img src="./assets/search_FILL0_wght500_GRAD0_opsz48 1.svg" width="80%" height="80%" alt="">
                </div>
                <div class="p-1 input-box " *ngIf="searchbar">
                    <button class="btn" (click)="drop()" style="    position: relative;
                    left: 5%;
                    top: 15%;"><i class="fa fa-times" aria-hidden="true"></i></button>
                </div>



            </div>
            <div class="col-md-2 col2 hand-b" (click)="table()">

                <div class="p-1 input-box">
                    <img src="./assets/tbl.svg" alt="" width="100%">
                </div>




            </div>


        </div>
    </div>
</div>